<script lang="ts">
    import {onMount, createEventDispatcher, onDestroy} from 'svelte'
  import { _ } from 'svelte-i18n';
  import { getContext } from 'svelte';
  import { dispatchLikeChangeEvent, getRequest, preventDefault, deleteSession, dispatchExerciseChangeEvent } from '../Util/utils';
  import route from '../Util/routes';
  import { bootstrapConfirmation } from '../Bootstrap';
  import type { Writable } from 'svelte/store';
  import { notifyApiError } from '../Util/notify';
  import { ErrorCode } from '../Util/errorCodes';
  import { askSlopeIntervals } from '../Common/mixedMode';

  export let session_id;
  export let isTemplate: boolean;
  export let allowed_to_edit = false; 
  export let allowed_to_delete = false; // this is for sessions
  export let copySession, copyThisSession;
  export let canDelete = true
  export let canFavorite = true
  export let canFlag = true

  export let selectable: boolean = false;

  export let enable_share_button = false;
  
  export let isSession = false;
  export let isActivity = false;
  export let isWorkout = false;

  export let name: string = null;
  export let path: string = null;

  export let deleteActivityCard: (string)=>any;
  export let reloadExercises: ()=>any;

  export let isStarred = false;
  export let isFlagged = false;
  export let isLiked = false;
  export let isDisliked = false;
  export let allowDownload = true;
  export let canSendToGarmin = false;
  export let canSendToZwift = false;
  export let canSendToWahoo = false;


  export let video_id, spotify_url, zoom_url;
  $: youtube_url = `https://youtu.be/${video_id}`;

  export let exercise = null;

  let root: HTMLElement;

  let session_join_url = window.location.origin + route('SessionsController@getSessionDetails', [session_id]);
  let xert = getContext("xert");

  export let isRecorded: boolean = false;
  export let isPlanned: boolean = false;
  let hasPowerData: boolean = false;
  let isGroupSession: boolean = false;
  let isOwnedSession: boolean = false;

  // let usePace = false
  function sendWorkoutsClickListener(event: MouseEvent) {
    const provider = (event.target as HTMLElement).getAttribute('data-provider')
    if (provider != null) {
      try {
        sendTo(provider)

        let popover = event.target.closest('.popover')
        if (popover) {
          jq(popover).confirmation('hide')
        }
      } catch (e) {
        console.warn(e)
      }
    }

    //  else if (event.target.getAttribute('name') == 'use-pace') {
    //   usePace = (event.target as HTMLInputElement).checked
    //   console.log('pace???', event)
    // }
  }

  function initWorkoutButtons(event) {
    const id = event.target.getAttribute('aria-describedby')
    let element = document.getElementById(id)
    if (element) {
      // Remove listener first so it isn't registered multiple times
      element.removeEventListener('click', sendWorkoutsClickListener)
      element.addEventListener('click', sendWorkoutsClickListener)
    }
  }
  function configureWorkoutButtons(path, garmin, zwift, wahoo) {
    let buttons = '';
        // icon: 'fa-light fa-2xl fa-square-z'
    const btnClass = "btn w-24 text-left btn-xs btn-primary px-4 py-2 mx-2 my-1";
    if (garmin) {
      // if (Xert._sport_type == "Running")
      //   buttons += `<span><a class="${btnClass} mr-4 logo-garmin" data-provider="garmin">Garmin</a><input type="checkbox" name="use-pace" id="pace-toggle-${path}" ${usePace ? 'checked' : ''}><label class="ml-2" for="pace-toggle-${path}">Use Pace</label></span>`
      // else
        buttons += `<a class="${btnClass} logo-garmin" data-provider="garmin">Garmin</a>`
    }
    if (zwift) buttons += `<a class="${btnClass} logo-zwift" data-provider="zwift">Zwift</a>`
    if (wahoo) buttons += `<a class="${btnClass} logo-wahoo" data-provider="wahoo">Wahoo</a>`
    if (!buttons.length) return null
    let template =
      '<div class="popover confirmation xert-svelte">' +
        '<div class="arrow"></div>' +
        '<h3 class="popover-title"></h3>' +
        '<div class="popover-content text-center">'+
          '<div class="flex flex-col">'+
            buttons+
            `<a class="${btnClass}" data-dismiss="confirmation"></a>`+
          '</div>'+
        '</div>'+
      '</div>'

    return template;
  }
  $: buttons = configureWorkoutButtons(path, canSendToGarmin, canSendToZwift, canSendToWahoo);

  async function deleteActivity() {
    await window.fetch("/activities/" + path, {method: 'DELETE'});
    deleteActivityCard(path);
  }

  function deleteThisSession() {
    deleteSession(path, isTemplate).catch(error=>{
      console.error(error)
    }).then(()=>{
      dispatchExerciseChangeEvent(root);
    });
  }

  async function flagActivity() {
    isFlagged = !isFlagged;

    let body = isFlagged ? '{"name": "flag", "value": 1}' : '{"name": "flag", "value": 0}';

    await window.fetch("/activities/" + path + "/attribute", {method: 'POST',
      ...getRequest(),
      body: body});
    await reloadExercises();
  }

  async function starActivity() {
    isStarred = !isStarred;
    
    let body = isStarred ? '{"name": "favourite", "value": 1}' : '{"name": "favourite", "value": 0}';

    await window.fetch("/activities/" + path + "/attribute", {method: 'POST',
      ...getRequest(),
      body: body});
  }

  async function likeWorkout(event) {
    isLiked = !isLiked;
    isDisliked = false;
    const response = await window.fetch("/workouts/like/" + path, {method: 'POST',
      ...getRequest()});
    const result = await response.json();
    isLiked = result.liked;

    dispatchLikeChangeEvent(path, 'Workout', isLiked, isDisliked, root);
  }

  async function dislikeWorkout(event) {
    isDisliked = !isDisliked;
    isLiked = false;
    const response = await window.fetch("/workouts/dislike/" + path, {method: 'POST',
      ...getRequest()});
    const result = await response.json();
    isDisliked = result.disliked;
    dispatchLikeChangeEvent(path, 'Workout', isLiked, isDisliked, root);
  }

  // TODO: en.json
  const successes = {
    "garmin": "Successfully uploaded as a regular Garmin workout. Use Garmin Connect to send it to your Garmin device.",
    "zwift": "Successfully uploaded workout to Zwift.",
    "wahoo": "Successfully uploaded workout to Wahoo."
  }
  const errors = {
    "garmin": "An error occurred, workout could not be properly sent to Garmin.",
    "zwift": "An error occurred, workout could not be properly sent to Zwift.",
    "wahoo": "An error occurred, workout could not be properly sent to Wahoo.",
  }

  async function sendTo(provider: string, usePace = false) {
    var body: { usePace?: boolean, slope_intervals?: string } = {};
    if (usePace) {
      body = {
        usePace: true,
      }
    } else {
      body = {};
    }
    if (provider == 'todo') return
    const slopeIntervals = await askSlopeIntervals(provider == 'garmin' ? 'garmin_connect' : provider as 'zwift' | 'wahoo', { path });
    if (slopeIntervals === null) return
    if (slopeIntervals) body.slope_intervals = slopeIntervals
    const response = await window.fetch(`/workout/to-${provider}-workout/${path}`, {method: 'POST', body: JSON.stringify(body),
  ...getRequest()});
    const result = await response.json();
    const workoutID = result.workoutId;
    
    if (response.ok) {
        Xert.success(successes[provider]);
      } else {
        Xert.warning(errors[provider]);
    }
  }

  function editSession(path: string, isTemplate: boolean = true) {
    const url = isTemplate ? route('SessionsController@getSessionEditor', [path]) : route('SessionsController@getSessionScheduler', [path]);
    window.open(url, '_session').focus();
  }
  
  function editActivity() {
    if(isSession && isOwnedSession){
      window.open('/session-instance/' + exercise.session_id + '/schedule');
    } else {
      dispatchEditEvent(new Date(), exercise);
    };
  }

  function dispatchEditEvent(date, exercise){
    let event = new CustomEvent("editEvent", {
      bubbles: true,
      detail: {
        date,
        exercise,
      }
    });
    root.dispatchEvent(event);
  }

  let jq = window.$;

  export async function downloadWorkout(path, name, ext) {
    let convertURL = route('WorkoutController@getConvertWorkout', [path]);
    const slopeIntervals = await askSlopeIntervals(ext, { path });
    if (slopeIntervals === null) return;
    var options = [{ name: ext, value: true }, { name: name }];
    if (slopeIntervals) options.push({ name: 'slope_intervals', value: slopeIntervals });
    jq.get(convertURL, options, function(data, status, xhr) {
      var name = options[1].name.length ? options[1].name + ' - Xert' : 'Untitled Workout - Xert';
      var blob = new Blob([data], { type: "text/plain;charset=utf-8" });
      window.saveAs(blob, name + "." + ext);
    }).fail((xhr) => {
      notifyApiError(xhr?.responseJSON, { code: ErrorCode.WORKOUT_EXPORT_FAILED, message: `Could not build the ${ext.toUpperCase()} file for this workout. Please try again in a moment.` });
    });
  }

  function confirmDeleteWorkout() {
    window.fetch(route("WorkoutController@deleteWorkout", [path]), {
      ...getRequest(),
      method: 'delete',
    })
    .then(results => results.json())
    .then(results => {
      if(typeof(reloadExercises) != "undefined") reloadExercises();
    });
  }
let activityContext:Writable<any> = getContext('modal_activity');
$: isPinned = $activityContext?.isPinned;
  function lockActivity(event: MouseEvent & { currentTarget: EventTarget & HTMLAnchorElement; }) { 
    $activityContext.isPinned = !$activityContext?.isPinned;
  }
</script>

<div class="container" bind:this={root}>
  {#if isSession}
    <buttons class="btns-row" >
        {#if allowed_to_edit}
        <a title={$_("sessions.card.edit_session")} on:auxclick={(e)=>{e.preventDefault(); editSession(path, isTemplate)}} on:click={()=>editSession(path, isTemplate)} href="javascript:;">
            <svg width="30" height="30" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="-10 0 528 512">
            <path fill="currentColor" d="M387 23q19 -19 45 -19v0q26 0 45 19l12 12q19 19 19 45t-19 45l-220 221q-13 12 -31 17l-90 21q-9 1 -15 -5t-5 -15l21 -90q5 -18 17 -32l221 -219v0zM455 45q-10 -9 -23 -9v0q-13 0 -23 9l-26 27l57 57l27 -26q9 -10 9 -23t-9 -23l-12 -12v0zM181 281l-16 66l65 -15 q10 -2 16 -10l171 -170l-57 -57l-171 171q-6 6 -8 15v0v0zM208 64q15 1 16 16q-1 15 -16 16h-128q-20 1 -34 14q-13 14 -14 34v288q1 20 14 34q14 13 34 14h288q20 -1 34 -14q13 -14 14 -34v-128q1 -15 16 -16q15 1 16 16v128q-1 34 -23 57q-23 22 -57 23h-288 q-34 -1 -57 -23q-22 -23 -23 -57v-288q1 -34 23 -57q23 -22 57 -23h128v0z"/>
            </svg>
        </a>
        {/if}
        {#if session_join_url && enable_share_button}
        <a title={$_("sessions.card.share_session")} href="javascript:;" on:auxclick={preventDefault}
            on:click={()=>{navigator.clipboard.writeText(session_join_url).then(()=>xert.info("Session URL copied to clipboard"));}}>
            <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="-10 0 468 512">
            <path fill="currentColor" d="M448 112q-1 34 -23 57v0q-23 22 -57 23q-35 -1 -58 -26l-151 77q1 6 1 13t-1 14l151 75q23 -24 58 -25q34 1 57 23q22 23 23 57q-1 34 -23 57q-23 22 -57 23q-34 -1 -57 -23q-22 -23 -23 -57q0 -15 5 -28l-146 -72q-23 34 -67 36q-34 -1 -57 -23q-22 -23 -23 -57 q1 -34 23 -57q23 -22 57 -23q44 2 67 37l146 -73q-5 -13 -5 -28q1 -34 23 -57q23 -22 57 -23q34 1 57 23q22 23 23 57v0v0zM79 304q21 -1 34 -14v0q14 -14 14 -34t-14 -34q-13 -13 -34 -14q-20 1 -34 14q-13 14 -14 34q1 20 14 34q14 13 34 14v0zM368 64q-20 1 -34 14v0 q-13 14 -14 34q1 20 14 34q14 13 34 14q20 -1 34 -14q13 -14 14 -34q-1 -20 -14 -34q-14 -13 -34 -14v0zM368 448q20 -1 34 -14v0q13 -14 14 -34q-1 -20 -14 -34q-14 -13 -34 -14q-20 1 -34 14q-13 14 -14 34q1 20 14 34q14 13 34 14v0z"/>
            </svg>
        </a>
        {/if}
        {#if copySession}
        <a title={$_("sessions.card.copy_session")} href="javascript:;" on:auxclick={(e)=>{e.preventDefault(); copyThisSession}} on:click={copyThisSession} >
            <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="-10 0 532 512">
            <path fill="currentColor" d="M272 416q-15 1 -16 16v16q0 14 -9 23t-23 9h-160q-14 0 -23 -9t-9 -23v-256q0 -14 9 -23t23 -9h112q15 -1 16 -16q-1 -15 -16 -16h-112q-27 1 -45 19t-19 45v256q1 27 19 45t45 19h160q27 -1 45 -19t19 -45v-16q-1 -15 -16 -16v0zM503 87l-78 -78q-9 -9 -22 -9h-115 q-27 1 -45 19t-19 45v256q1 27 19 45t45 19h160q27 -1 45 -19t19 -45v-211q0 -13 -9 -22v0zM416 45l51 51h-51v-51v0zM480 320q0 14 -9 23v0q-9 9 -23 9h-160q-14 0 -23 -9t-9 -23v-256q0 -14 9 -23t23 -9h96v64q0 14 9 23t23 9h64v192v0z"/>
            </svg>
        </a>
        {/if}
        {#if video_id}
        <a target="_blank" rel="noopener noreferrer" title={youtube_url} href={youtube_url}>
            <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 575 512">
            <path stroke="currentColor" stroke-width="32" fill="none" d="M 547.65351,125.73817 C 541.40856,102.22391 523.00876,83.704803 499.64659,77.42008 457.30099,66 287.50001,66 287.50001,66 c 0,0 -169.79999,0 -212.146569,11.42008 C 51.991276,83.705793 33.591472,102.22391 27.346515,125.73817 16,168.35916 16,257.28387 16,257.28387 c 0,0 0,88.92469 11.346515,131.54564 6.244957,23.51427 24.644761,41.26186 48.006926,47.54656 42.346579,11.42008 212.146569,11.42008 212.146569,11.42008 0,0 169.8,0 212.14658,-11.42008 23.36217,-6.2847 41.76197,-24.03229 48.00692,-47.54656 11.34652,-42.62095 11.34652,-131.54564 11.34652,-131.54564 0,0 0,-88.92471 -11.34652,-131.5457 z M 231.96553,333.0208 V 181.54689 c 0,-2.23036 2.40734,-3.63045 4.34593,-2.52758 l 133.22805,75.79412 c 1.91724,1.09073 1.91721,3.85406 -5e-5,4.94475 l -133.22795,75.79029 a 2.9080519,2.9080519 30.182727 0 1 -4.34598,-2.52767 z"/>
            </svg>
        </a>
        {/if}
        {#if zoom_url}
        <a target="_blank" rel="noopener noreferrer" title={$_("sessions.card.zoom")} href={zoom_url}>
            <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="-10 0 596 512">
            <path fill="currentColor" d="M559 100q-17 -9 -33 2l-103 72q-11 9 -4 22q9 11 22 4l103 -72v256l-103 -72q-13 -7 -22 4q-7 13 4 22l103 72q8 6 18 6q8 0 15 -4q16 -9 17 -29v-255q-1 -19 -17 -28v0zM320 64h-256q-27 1 -45 19t-19 45v256q1 27 19 45t45 19h256q27 -1 45 -19t19 -45v-256 q-1 -27 -19 -45t-45 -19v0zM352 384q0 14 -9 23v0q-9 9 -23 9h-256q-14 0 -23 -9t-9 -23v-256q0 -14 9 -23t23 -9h256q14 0 23 9t9 23v256v0z"/>
            </svg>
        </a>
        {/if}
        {#if spotify_url}
        <a target="_blank" rel="noopener noreferrer" title={spotify_url} href={spotify_url}>
            <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 500 500">
            <path xmlns="http://www.w3.org/2000/svg" stroke="currentColor" stroke-width="22" fill="none" d="m 345.35983,364.37502 c -3.97727,0 -6.4394,-1.23106 -10.13258,-3.40909 -59.09091,-35.60606 -127.84091,-37.12122 -195.73863,-23.20076 -3.69319,0.94697 -8.52273,2.46212 -11.26894,2.46212 -9.18561,0 -14.96212,-7.29167 -14.96212,-14.96212 0,-9.75379 5.77651,-14.39394 12.87878,-15.90909 77.55682,-17.14015 156.81819,-15.625 224.43182,24.8106 5.77652,3.69319 9.18561,7.00758 9.18561,15.625 0,8.61743 -6.72349,14.58334 -14.39394,14.58334 z m 25.47348,-62.12121 c -4.92424,0 -8.23863,-2.17803 -11.64772,-3.97728 -59.18561,-35.03788 -147.44319,-49.14772 -225.94697,-27.84091 -4.54546,1.23106 -7.00758,2.46212 -11.26894,2.46212 -10.13258,0 -18.37121,-8.23863 -18.37121,-18.37121 0,-10.13257 4.92424,-16.85606 14.67803,-19.60227 26.32575,-7.38636 53.21969,-12.87879 92.61363,-12.87879 61.45833,0 120.83333,15.24621 167.61364,43.08712 7.67045,4.54546 10.70076,10.41667 10.70076,18.65531 -0.0947,10.22727 -8.04925,18.46591 -18.37122,18.46591 z m 29.35606,-72.1591 c -4.92424,0 -7.95454,-1.23106 -12.21591,-3.69318 -67.42424,-40.24621 -187.97348,-49.9053 -266.00378,-28.125 -3.40909,0.94697 -7.67046,2.46212 -12.21591,2.46212 -12.499997,0 -22.064391,-9.75378 -22.064391,-22.34848 0,-12.87879 7.954545,-20.17046 16.477271,-22.63258 33.33333,-9.75378 70.64394,-14.39394 111.26894,-14.39394 69.12878,0 141.57197,14.39394 194.50757,45.26516 7.38637,4.26136 12.21591,10.13257 12.21591,21.40151 0,12.87879 -10.41667,22.06439 -21.9697,22.06439 z"/>
            <path xmlns="http://www.w3.org/2000/svg" stroke="currentColor" stroke-width="32" fill="none" d="M 250.0001,16 C 120.82826,16 16,120.82827 16,250.00009 c 0,129.17184 104.82826,234.00009 234.0001,234.00009 129.17185,0 234.0001,-104.82825 234.0001,-234.00009 C 484.0002,120.82827 379.17195,16 250.0001,16 Z"/>
            </svg>
        </a>
        {/if}
        <!-- We don't want to show the delete for isCalendarPicker -->
        {#if allowed_to_delete && !selectable} 
        <a use:bootstrapConfirmation={{
            onclick: deleteThisSession,
            title: $_("sessions.card.delete_session"),
            placement: 'top'
        }} href="javascript:;" data-singleton="true" data-popout="true" style="font-size: 14px !important;"><span title={$_("sessions.card.delete_session")}><i class="fa-light fa-trash-can fa-2xl delete-session"></i></span></a>
      {/if}
    </buttons>
  {:else if isActivity}
    <buttons class="btns-row" >
        {#if isRecorded && canFlag}
          <a title="Flag the breakthrough as invalid." class:flagged={isFlagged} rel="noopener noreferrer" on:click={async () => {await flagActivity()}} href="javascript:;">
              <i class="{isFlagged ? "fa-solid" : "fa-light"} fa-flag fa-2xl"/>
          </a>
        {/if}
        {#if isRecorded && canFavorite}
          <a title="Star this activity" class:starred={isStarred} rel="noopener noreferrer" on:click={async () => {await starActivity()}} href="javascript:;">
            <i class="{isStarred ? "fa-solid" : "fa-light"} fa-star fa-2xl"/>
          </a>
        {/if}
        {#if !selectable && canDelete}
        <a use:bootstrapConfirmation={{
            onclick: deleteActivity,
            placement: 'top',
            title: "Delete this activity" 
        }} title = "Delete this activity" rel="noopener noreferrer" href="javascript:;">
            <i class="fa-light fa-trash-can fa-2xl" data-placement="left"></i>
        </a>
        {/if}
        {#if isPlanned && $activityContext }
        <a title= {(isPinned?"Unpin from":"Pin to")+" Calendar" } style="" on:click ={lockActivity} href="javascript:;"> 
            <i class ={((isPinned)?"fa-solid":"fa-light")+" fa-thumbtack fa-2xl"} ></i>
        </a>
        {/if}

    </buttons>
  {:else if isWorkout}
  
    {#if allowDownload}
    <buttons class="btns-row" >
        <a title="Download as ZWO" rel="noopener noreferrer" href="javascript:;"  on:click|stopPropagation={() => {downloadWorkout(path, name, "zwo")}}>
        <button>
            <span>
            <i class="fa fa-circle-arrow-down"></i>
            <p>ZWO</p>
            </span>
        </button>
        </a>
        <a title="Download as TCX" rel="noopener noreferrer" href="javascript:;" on:click|stopPropagation={() => {downloadWorkout(path, name, "tcx")}}>
        <button>
            <span>
            <i class="fa fa-circle-arrow-down"></i>
            <p>TCX</p>
            </span>
        </button>
        </a>
        <a title="Download as ERG" rel="noopener noreferrer" href="javascript:;" on:click|stopPropagation={() => {downloadWorkout(path, name, "erg")}}>
        <button>
            <span>
            <i class="fa fa-circle-arrow-down"></i>
            <p>ERG</p>
            </span>
        </button>
        </a>
    </buttons>
    {/if}
    <buttons class="btns-row" >
    <a title="Like this Workout" rel="noopener noreferrer" on:click|stopPropagation={async (event) => {await likeWorkout(event)}} href="javascript:;">
        {#if isLiked}
          <i class="fa-solid fa-thumbs-up fa-2xl"></i>
        {:else}
        <i class="fa-light fa-thumbs-up fa-2xl"></i>
        {/if}
    </a>
    <a title="Dislike this Workout" rel="noopener noreferrer" on:click|stopPropagation={async (event) => {await dislikeWorkout(event)}} href="javascript:;">
      {#if isDisliked}
        <i class="fa-solid fa-thumbs-down fa-2xl"></i>
      {:else}
      <i class="fa-light fa-thumbs-down fa-2xl"></i>
      {/if}
    </a>
    {#if isPlanned }
    <a title= {(isPinned?"Unpin from":"Pin to")+" Calendar" } style="" on:click ={lockActivity} href="javascript:;"> 
       {#if $activityContext }
        <i class ={(isPinned?"fa-solid":"fa-light")+" fa-thumbtack fa-2xl"} ></i>
        {/if}
    </a>
    {/if}
    {#if buttons}
      <a use:bootstrapConfirmation={{
        onclick: ()=>sendTo('todo'),
        // oncancel: ()=>sendTo('todo', true),
        title: "Send Workout To",
        placement: 'top',

        cancelMessage: 'Cancel',
        btnCancelClass: "btn btn-xs btn-primary",
        btnCancelIcon: '<i class="glyphicon glyphicon-remove mr-2"></i>',
        okMessage: null,
        // btnOkClass: "btn btn-xs btn-primary",
        // btnOkIcon: null,
        
        template: buttons,
        onShow: initWorkoutButtons

      }} rel="noopener noreferrer"  href="javascript:;">
        <i data-toggle="tooltip" title="Send Workout" class="fa-light fa-2xl fa-paper-plane"></i>
      </a>
    {/if}

    {#if allowed_to_edit}
      <a use:bootstrapConfirmation={{
        onclick: confirmDeleteWorkout,
        placement: 'top',
        title: "Delete this workout"
      }} rel="noopener noreferrer" href="javascript:;">
        <i class="fa-light fa-trash-can fa-2xl" data-placement="left"></i>
      </a>
    {/if}
    </buttons>
  {/if}
    </div>

<style lang="scss">
  @import '../style/xert.scss';
buttons {
  display: inline-flex;
  height: fit-content;

  gap: 10px;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 10px 0;
}



a {
  --border: 1px solid var(--color-xert-gray);
  --borderRadius: 5px !important;
  color: inherit;
//   margin: auto;
  flex-shrink: 1;

  > button {
    border: 1px solid var(--color-xert-gray-text);
    border-top-right-radius: var(--borderRadius) !important;
    border-bottom-right-radius: var(--borderRadius) !important;
    border-left: none !important;
    background-color: white;

    > span {
      vertical-align: text-bottom;
    }
    > span > p {
      margin: 0;
      line-height: 12px;
      font-size: 15px;
      font-family: "Open Sans", sans-serif;
      display: inline-block !important;
      vertical-align: middle;
    }

    > span > i {
      vertical-align: middle;
      font-size: 14px;
    }
  }

  > button, > button:focus {
    border-radius: var(--borderRadius) !important;
    background-color: white;
    border: var(--border) !important;
  }

  > button:hover, > button:active {
    color: var(--color-xert-teal);
    border-color: var(---color-xert-teal) !important;
    background-color: white;
  }
}

a > svg, a > i {
  color: inherit;
  &:hover {
    color: var(--color-xert-teal) !important;
  }
}

.flagged > svg{
  color: #F04B2E !important;
  &:hover {
    color: #FF7259 !important;
  }
}

.starred > svg{
  color: #FFA500 !important;
  &:hover {
    color: #FFC354 !important;
  }
}

.delete-session {
  display: flex;
  width: 30px;
  height: 30px;
  align-items: center;
  padding-bottom: 4px;
}
:global(.logo-garmin:before){
  mask-image: url("/assets/global/img/providers/garmin.svg");
  display: inline-block;
  background-color: white;
  height: 14px;
  width: 16px;
  mask-size: cover;
  margin-bottom: -3px;
  content: '';
  margin-right: 8px;
}
:global(.logo-zwift:before){
  mask-image: url("/assets/global/img/providers/zwift.svg");
  display: inline-block;
  background-color: white;
  height: 14px;
  width: 16px;
  mask-size: cover;
  margin-bottom: -3px;
  content: '';
  margin-right: 8px;
}
:global(.logo-wahoo:before){
  mask-image: url("/assets/global/img/providers/wahoo-elemnt.png");
  display: inline-block;
  background-color: white;
  height: 14px;
  width: 12px;
  margin-left: 2px;
  mask-size: cover;
  margin-bottom: -3px;
  content: '';
  margin-right: 10px;
}
</style>
  
